<div class="mt-4">
  <h2 class="mb-3">{{ 'USERS_TITLE' | translate }}</h2>

  @if (loadingCategories$ | async) {
    <div class="text-center my-3">
      <app-loading></app-loading>
    </div>
  }

  <!-- Search Form -->
  <form [formGroup]="searchForm" (ngSubmit)="search()" class="p-4 bg-dark rounded">
    <div class="row">
      <div class="col-lg-9 col-md-9 col-sm-12">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3">
            <input
              type="text"
              formControlName="name"
              class="form-control"
              placeholder="{{ 'NAME' | translate }}"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3" *hasRole="[roles.Admin, roles.Editor]">
            <input
              type="email"
              formControlName="email"
              class="form-control"
              placeholder="{{ 'EMAIL' | translate }}"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3" *hasRole="[roles.Admin, roles.Editor]">
            <input
              type="tel"
              formControlName="phoneNumber"
              class="form-control"
              placeholder="{{ 'MOBILE' | translate }}"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3" *hasRole="[roles.Admin, roles.Editor]">
            <ng-select
              [items]="roleOptions"
              placeholder="{{ 'USERS_SEARCH_ROLE' | translate }}"
              formControlName="role"
              [searchable]="false"
            >
            </ng-select>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3" *hasRole="[roles.Admin, roles.Editor]">
            <ng-select
              [items]="statuses"
              placeholder="{{ 'STATUS' | translate }}"
              formControlName="status"
              [searchable]="false"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item | translate }}
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                {{ item | translate }}
              </ng-template>
            </ng-select>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pb-3" *hasRole="[roles.Admin, roles.Editor]">
            <ng-select
              [items]="plans"
              formControlName="plan"
              placeholder="{{ 'PLAN' | translate }}"
              [searchable]="false"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ item | translate }}
                <app-plan-type [plan]="item" classes="px-1"></app-plan-type>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                {{ item | translate }}
                <app-plan-type [plan]="item" classes="px-1"></app-plan-type>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12">
        <div class="row">
          <div class="col-12">
            <button type="submit" class="btn btn-primary">{{ 'SEARCH_BUTTON' | translate }}</button>
            <button
              type="button"
              class="btn btn-secondary bg-black text-primary mx-3"
              (click)="reset()"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  @if (loadingUsers$ | async) {
    <div class="text-center my-3">
      <app-loading></app-loading>
    </div>
  } @else {
    @if (users$ | async; as users) {
      <app-user-search-result
        (mapChanged)="mapChanged($event)"
        (onListView)="clearMapData()"
        [mapParameters]="mapParameters"
      ></app-user-search-result>
    }
  }
</div>
